<template>
  <div>
    <h2>Crear prospecto</h2>
    <el-form
      :model="model"
      :rules="rules"
      label-position="top"
      size="mini"
      ref="form"
      v-loading="loading_form"
    >
      <el-alert
        title="Recuerde crear el contacto al terminar de llenar este formulario"
        type="info"
        effect="dark"
      >
      </el-alert>
      <br />
      <el-row :gutter="10">
        <el-col :span="12">
          <el-card>
            <h3>Datos del prospecto</h3>

            <el-form-item label="Empresa" prop="MagycorpCompanyId">
              <el-input disabled v-model="model.MagycorpCompanyId"></el-input>
            </el-form-item>

            <!-- TODO: Esto debe salir solo cuando el rol lo amerite -->
            <!-- <el-form-item label="Vendedor" prop="SalesPersonCode"> -->
            <!--   <el-select -->
            <!--     v-model="model.SalesPersonCode" -->
            <!--     placeholder="Seleccionar Vendedor" -->
            <!--     filterable -->
            <!--     @change="handleChangeSeller" -->
            <!--   > -->
            <!--     <el-option -->
            <!--       v-for="item in sellersList" -->
            <!--       :key="item.SalesPersonCode" -->
            <!--       :value="item.SalesPersonCode" -->
            <!--       :label="item.FullName" -->
            <!--       :disabled="item.IsEnabled" -->
            <!--     ></el-option> -->
            <!--   </el-select> -->
            <!-- </el-form-item> -->
            <el-form-item label="Nombre de compañia" prop="CompanyName">
              <el-input v-model="model.CompanyName"></el-input>
            </el-form-item>
            <el-form-item label="RNC" prop="VatRegistrationNumber">
              <el-input
                size="mini"
                v-model="model.VatRegistrationNumber"
                :style="{ width: '300px' }"
              ></el-input>

              <!-- <el-input     size="mini"  v-model="model.VatRegistrationNumber"></el-input> -->
            </el-form-item>

            <el-form-item label="Dirección" prop="Address">
              <el-col :span="11">
                <el-input
                  v-model="model.Address"
                  placeholder="Dirección"
                ></el-input>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-input v-model="model.City" placeholder="Ciudad"></el-input>
              </el-col>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="Vendedor" prop="SellerId">
                  <seller-selector
                    v-model="model.SellerId"
                    @selected-seller="handleSelectedSeller"
                    @change="changeVendor"
                  ></seller-selector>
                </el-form-item>

                <el-form-item label="Soporte de ventas" prop="SupportSellerId">
                  <support-seller-selector
                    v-model="model.SupportSellerId"
                    :byUser="true"
                  ></support-seller-selector>
                </el-form-item>

                <el-form-item
                  label="Servicio al cliente"
                  prop="CustomerServiceId"
                >
                  <customer-service-selector
                    v-model="model.CustomerServiceId"
                  ></customer-service-selector>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="Cantidad de Empleados"
                  prop="EmployeesAmount"
                >
                  <el-input-number
                    v-model="model.EmployeesAmount"
                    :min="0"
                  ></el-input-number>
                </el-form-item>

                <el-form-item label="Cantidad de PC" prop="ComputersAmount">
                  <el-input-number
                    v-model="model.ComputersAmount"
                    :min="0"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="Cantidad de Sucursales"
                  prop="SucursalesAmount"
                >
                  <el-input-number
                    v-model="model.SucursalesAmount"
                    :min="0"
                  ></el-input-number>
                </el-form-item>

                <el-form-item
                  label="Cantidad de clientes"
                  prop="CustomerAmount"
                >
                  <el-input-number
                    v-model="model.CustomerAmount"
                    :min="0"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- <el-form-item label="Ciudad" prop="City">
            </el-form-item> -->
          </el-card>
        </el-col>

        <el-col :span="12">
          <el-card>
            <h3>Datos del contacto</h3>
            <el-col :span="11">
              <el-form-item label="Primer nombre" prop="FirstName">
                <el-input
                  v-model="model.FirstName"
                  :style="{ width: '300px' }"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="1"></el-col>
            <el-col :span="10">
              <el-form-item label="Segundo nombre">
                <el-input
                  v-model="model.MiddleName"
                  :style="{ width: '300px' }"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="11">
              <el-form-item label="Apellidos" prop="SurName">
                <el-input
                  v-model="model.SurName"
                  :style="{ width: '300px' }"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="1"></el-col>
            <el-col :span="10">
              <el-form-item label="Puesto" prop="JobTitle">
                <el-input
                  v-model="model.JobTitle"
                  :style="{ width: '300px' }"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-form-item label="Número de teléfono" prop="PhoneNumber">
              <el-col :span="11">
                <el-input
                  v-model="model.PhoneNumber"
                  placeholder="Teléfono"
                  :style="{ width: '300px' }"
                ></el-input>
              </el-col>
              <el-col class="line" :span="1"></el-col>
              <el-col :span="10">
                <el-input
                  v-model="model.ExtensionNumber"
                  placeholder="Extensión"
                  :style="{ width: '100px' }"
                ></el-input>
              </el-col>
            </el-form-item>
            <el-col :span="11">
              <el-form-item label="Número de celular">
                <el-input
                  v-model="model.MobilePhoneNumber"
                  :style="{ width: '300px' }"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="1"></el-col>

            <el-col :span="10">
              <el-form-item label="Correo" prop="Email">
                <el-input
                  v-model="model.Email"
                  :style="{ width: '300px' }"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :offset="17">
              <el-button-group>
                <el-col :span="12">
                  <el-button
                    type="info"
                    title="Cancelar y volver atras"
                    @click="rollback"
                    size="mini"
                    >Cancelar</el-button
                  >
                  <!-- <el-col :span="16" > -->
                </el-col>
                <el-col :span="12">
                  <el-button
                    type="primary"
                    icon="el-icon-check"
                    @click="save"
                    size="mini"
                    >Guardar</el-button
                  >
                </el-col>

                <!-- <el-button type="warning" @click="reset" size="mini"
                >Resetear</el-button
                > -->
              </el-button-group>
            </el-col>
          </el-card>
        </el-col>
        <!-- <el-row :gutter="250" > -->

        <!-- </el-col> -->
        <!-- </el-row> -->
      </el-row>
    </el-form>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
import Roles from "@/roles";
import SupportSellerSelector from "@/components/Company/SupportSellerSelector.vue";
import SellerSelector from "@/components/Company/SellerSelector.vue";
import CustomerServiceSelector from "@/components/Company/CustomerServiceSelector.vue";

export default {
  name: "ProspectCreate",
  components: {
    SupportSellerSelector,
    SellerSelector,
    CustomerServiceSelector
  },
  data() {
    return {
      queryStringObjct: {},
      loading_form: false,
      model: {
        SalesPersonName: this.$store.state.user.user.SalesPersonName,
        CompanyName: "",
        VatRegistrationNumber: "",
        Address: "",
        AddressTwo: "",
        City: "",
        FirstName: "",
        MiddleName: "",
        SurName: "",
        JobTitle: "",
        PhoneNumber: "",
        ExtensionNumber: "",
        MobilePhoneNumber: "",
        Email: "",
        Number: "",
        PictureDirectory: "",
        Birthday: "2020-08-13T15:54:09.551Z",
        MagycorpCompanyId: this.$store.state.user.user.CompanySelected,
        SalesPersonCode: this.$store.state.user.user.SalesPersonCode,
        //SalesPersonName: this.$store.state.user.user.FullName
        //SalesPersonCode: this.$store.state.user.user.PersonCode,
        SellerId: null,
        SupportSellerId: null,
        CustomerServiceId: null,
        EmployeesAmount: "",
        ComputersAmount: "",
        CustomerAmount: "",
        SucursalesAmount: ""
      },
      rules: {
        SalesPersonCode: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        FirstName: [{ required: true, trigger: "blur", message: "Requerido" }],
        MiddleName: [{ required: true, trigger: "blur", message: "Requerido" }],
        SurName: [{ required: true, trigger: "blur", message: "Requerido" }],
        JobTitle: [{ required: true, trigger: "blur", message: "Requerido" }],
        PhoneNumber: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        MobilePhoneNumber: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        Email: [{ required: true, trigger: "blur", message: "Requerido" }],
        VatRegistrationNumber: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        CompanyName: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        City: [{ required: true, trigger: "blur", message: "Requerido" }],
        Address: [{ required: true, trigger: "blur", message: "Requerido" }],
        SellerId: [{ required: true, trigger: "blur", message: "Requerido" }],
        EmployeesAmount: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        CustomerAmount: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        SucursalesAmount: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        ComputersAmount: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],

        SupportSellerId: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        CustomerServiceId: [
          { required: true, trigger: "blur", message: "Requerido" }
        ]
      }
    };
  },
  computed: {
    isVendor() {
      return this.IsInRoles([
        Roles.SoporteVentas,
        Roles.EjecutivoDeVentas,
        "all"
      ]);
    }
  },
  mounted() {
    this.list_vendorsV2();
    this.queryStringObjct = this.$route.query;
    this.model.CompanyName =
      this.queryStringObjct != undefined ? this.queryStringObjct.Company : "";

    this.model.PhoneNumber =
      this.queryStringObjct != undefined
        ? this.queryStringObjct.PhoneNumber
        : "";
    this.model.FirstName =
      this.queryStringObjct != undefined ? this.queryStringObjct.FirstName : "";
    this.model.Email =
      this.queryStringObjct != undefined ? this.queryStringObjct.Email : "";
  },
  methods: {
    // updateStatusLeads(statusToUpdate = Boolean) {
    //   this.$http
    //     .post("/api/leads/Update", {
    //       id: this.$route.query.No,
    //       status: statusToUpdate
    //     })
    //     .then(() => {})
    //     .catch(error => {
    //       this.$message.error(
    //         JSON.parse(error.response.data.Message).Errors[0]
    //       );
    //     });
    // },
    changeVendor(vendor) {
      //console.log("VENDOR: ", vendor);
      this.model.SellerId = vendor;
    },
    changeSupportSeller(supportseller) {
      this.model.SupportSellerId = supportseller;
    },
    changeCustomerService(customerservice) {
      this.model.CustomerServiceId = customerservice;
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading_form = true;

          const new_prospect = this.model;
          if (this.isVendor) {
            new_prospect.SalesPersonName = this.currentUser.FullName;
            new_prospect.SalesPersonCode = this.currentUser.PersonCode;
          }

          this.$http
            .post("/api/prospects", new_prospect)
            .then(() => {
              // if (this.$route.query.No != undefined) {
              //   this.updateStatusLeads(true);
              // }
              this.$router.push({ name: "sales-prospects-list" });
              this.$message.success("Prospecto creado");
              this.loading_form = false;
            })
            .catch((error) => {
              this.$message.error(
                JSON.parse(error.response.data.Message).Errors[0]
              );
              this.loading_form = false;
            });
        } else {
          return false;
        }
      });
    },

    rollback() {
      this.$refs.form.resetFields();
      this.$router.go(-1);
    },
    reset() {
      this.$refs.form.resetFields();
      this.model.ExtensionNumber = "";
      this.model.MobilePhoneNumber = "";
    },
    // TODO: Esto solo se usa con el selector de vendedor
    handleChangeSeller(seller) {
      const vendor = this.sellersList.find((v) => v.SalesPersonCode === seller);
      this.model.SalesPersonName = vendor.FullName;
    },

    list_vendorsV2() {
      this.$http
        .get(`/api/prospects/sellers?company=${this.model.MagycorpCompanyId}`)
        .then((resp) => {
          const sellerMapers = resp.data.map((i) => {
            return {
              SalesPersonCode: i.SalesPersonCode,
              FullName: i.FullName,
              IsEnabled: i.IsEnabled
            };
          });
          this.sellersList = sellerMapers;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    handleSelectedSeller(seller) {
      this.model.SalesPersonCode = seller.value;
      this.model.SalesPersonName = seller.label;
    }
  }
};
</script>

<style></style>
